import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import {
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

export const getDefaultStateForProps = (dueDate) => ({ dueDate });

export class EditEventDueDateComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = getDefaultStateForProps(props.dueDate);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dueDate && prevProps.dueDate !== this.props.dueDate) {
      this.setState(getDefaultStateForProps(this.props.dueDate));
    }
  }

  handleDueDateChange = (e) => {
    const changedValue = e
      // eslint-disable-next-line no-underscore-dangle
      ? new Date(e._d)
      : null;
    this.setState({ dueDate: { value: changedValue } });
    this.props.onUpdate(changedValue);
  }

  render() {
    const { dueDate } = this.state;
    const {
      label,
      helperText,
    } = this.props;
    return (
      <DateTimePicker
        required={false}
        inputVariant="outlined"
        value={dueDate}
        label={label}
        helperText={helperText}
        emptyLabel=""
        onChange={this.handleDueDateChange}
        minDate={new Date()}
        // clearable  // Do we want to allow removing date? Api doesn't allow nulling out an existing date right now
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <CalendarTodayIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
}

EditEventDueDateComponent.propTypes = {
  onUpdate: PropTypes.func,
  dueDate: PropTypes.instanceOf(Date),
  label: PropTypes.string,
  helperText: PropTypes.string,
};

EditEventDueDateComponent.defaultProps = {
  onUpdate: () => {},
  dueDate: null,
  label: null,
  helperText: null,
};

export default EditEventDueDateComponent;
